import "font-awesome/scss/font-awesome.scss";
import './styles/main.scss'
import 'vue-select/dist/vue-select.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import moment from 'moment/src/moment';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css'
import jQuery from 'jquery';
global.jQuery = jQuery;
global.$ = jQuery;
require('bootstrap');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4')();
require('datatables.net-buttons/js/buttons.html5.js')();
window.moment = moment;
import "toastr";
import "toastr/toastr.scss";
